import { MDBCol, MDBRow } from "mdbreact";
import { Input, Label } from "abs-ui-components";
import "./FEUChildEnergyConsumption.scss";
import { energyconsumptionHeaders } from "../../../FEUChildConstant";
import { roundOff } from "../../../../../../../services/utilities";

const FEUChildEnergyConsumption = ({ energyConsumption }) => {
    const hasData = energyConsumption && energyConsumption.length > 0;

    return (
        <div className="mt-2 feu-reporsummary-container m-3">
            {hasData && (
                <MDBRow className="mt-3 header-row">
                    <MDBCol className="col-2 pl-0 d-flex justify-content-center align-items-center">
                        <Label name="" bold className="mt-4" />
                    </MDBCol>
                    <MDBCol className="col-10 text">
                        <MDBRow>
                            {Object.keys(energyconsumptionHeaders)?.map((key, idx) => (
                                <MDBCol key={idx}>
                                    <Label name={energyconsumptionHeaders[key]} bold />
                                </MDBCol>
                            ))}
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
            )}

            {hasData && (
                <div>
                    {energyConsumption?.map((row, index) => {
                        const consumptionValues = Object.keys(energyconsumptionHeaders)?.map((key) => ({
                            metaKey: energyconsumptionHeaders[key],
                            metadataValue: row[key],
                        }));

                        let categoryLabel = "";
                        if (row.name === "total") {
                            categoryLabel = "a)";
                        } else {
                            categoryLabel = `a.${index})`;
                        }

                        return (
                            <div key={`feuenergyconsumption-${index}`} className="mt-2 m-3">
                                <MDBRow className="mt-3">
                                    <MDBCol className="col-2 d-flex align-items-center">
                                        {row.name === "total" ? (
                                            <span className="totals-label">
                                                {`${categoryLabel} ${row.description}`}
                                            </span>
                                        ) : (
                                            <Label
                                                name={`${categoryLabel} ${row.description}`}
                                                className="sub-category-label"
                                            />
                                        )}
                                    </MDBCol>

                                    <MDBCol className="col-10">
                                        <MDBRow>
                                            {consumptionValues?.map((item, idx) => {
                                                const isZero =
                                                    parseFloat(item.metadataValue) === 0 ||
                                                    item.metadataValue === "0" ||
                                                    item.metadataValue === "0.0" ||
                                                    item.metadataValue === "0.00" ||
                                                    item.metadataValue === "0.000";

                                                const isNullOrEmpty =
                                                    item.metadataValue === null ||
                                                    item.metadataValue === undefined ||
                                                    item.metadataValue === "";

                                                const rowsToHide = [
                                                    "Assigned to OPS",
                                                    "Assigned to SSE",
                                                    "Assigned to ZET",
                                                    "Additional energy due to ice conditions",
                                                    "Additional energy due to ice class",
                                                ];

                                                const headersToHide = [
                                                    "GHG Target (g CO2eq/MJ)",
                                                    "Compliance Balance (MT CO2eq)",
                                                ];

                                                const alwaysShowHeaders = ["Energy amount Considered (GJ)"];

                                                const isOpsOrSseElectricityField =
                                                    (row.description?.toLowerCase().includes("assigned to ops") ||
                                                        row.description?.toLowerCase().includes("assigned to sse")) &&
                                                    item.metaKey === "Electricity amount (MWh)";

                                                const isZetElectricityField =
                                                    row.description?.toLowerCase().includes("assigned to zet") &&
                                                    item.metaKey === "Electricity amount (MWh)";

                                                const shouldHideInput =
                                                    isNullOrEmpty ||
                                                    (isZero &&
                                                        !alwaysShowHeaders.includes(item.metaKey) &&
                                                        !isZetElectricityField &&
                                                        !isOpsOrSseElectricityField &&
                                                        (rowsToHide.some((text) =>
                                                            row.description?.toLowerCase().includes(text.toLowerCase())
                                                        ) ||
                                                            headersToHide.includes(item.metaKey)));

                                                return (
                                                    <MDBCol key={idx} title={item.metadataValue ?? ""}>
                                                        {!shouldHideInput ? (
                                                            <Input
                                                                title={item.metadataValue}
                                                                value={roundOff(item.metadataValue, 3, 3)}
                                                                autoFocus={false}
                                                                className="report-summmery-input"
                                                                readOnly
                                                            />
                                                        ) : (
                                                            <div className="empty-cell"></div>
                                                        )}
                                                    </MDBCol>
                                                );
                                            })}
                                        </MDBRow>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default FEUChildEnergyConsumption;
